module.exports = __webpack_public_path__ + "static/media/Equipments.0db38948.png";